import { Pipe, PipeTransform } from '@angular/core';
import { toCamelCase } from '../utils';

@Pipe({
    name: 'camelCase',
  standalone: false
})
export class CamelCasePipe implements PipeTransform {
  transform(value: string): string {
    return toCamelCase(value);
  }
}
